import { mapActions } from "vuex";

export default  {
	created () {    
	   
	},
	methods: 
    {	
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'afiliacionFtn': 
							await this.resetDataForm({state: 'afiliacion_registro'})

							let servicios_nuevos=[]							
							for (let i = 0; i < this.dataForm[this.namePath].servicios_nuevos.length; i++) {
								this.dataForm[this.namePath].servicios_nuevos[i].id_info_ingresos=null
								this.dataForm[this.namePath].servicios_nuevos[i].id_afiliacion_registro=null
								servicios_nuevos.push(this.dataForm[this.namePath].servicios_nuevos[i])								
							}
							const await1 = this.updateDataForm({state: 'servicios_nuevos', data: servicios_nuevos})
							
							let servicios_activos=[]							
							for (let i = 0; i < this.dataForm[this.namePath].servicios_activos.length; i++) {
								this.dataForm[this.namePath].servicios_activos[i].id_info_ingresos=null
								this.dataForm[this.namePath].servicios_activos[i].id_afiliacion_registro=null
								servicios_activos.push(this.dataForm[this.namePath].servicios_activos[i])								
							}
							const await2 = this.updateDataForm({state: 'servicios_activos', data: servicios_activos})

							const await3 = this.updateDataForm({state:'afiliacion_registro/fecha', data: this.fecha().fecha.minHoy})
							
							const await4 = this.updateDataForm({state:'afiliacion_registro/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon})
							const await5 = this.updateDataForm({state:'afiliacion_registro/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor})
							const await6 = this.updateDataForm({state:'afiliacion_registro/valor', data: this.dataForm[this.namePath].info_ingresos.valor})
							const await7 = this.updateDataForm({state:'afiliacion_registro/reporte', data: this.dataForm[this.namePath].info_ingresos.reporte})
							const await8 = this.updateDataForm({state:'afiliacion_registro/comision', data: this.dataForm[this.namePath].info_ingresos.valor-this.dataForm[this.namePath].info_ingresos.reporte})
							const await9 = this.updateDataForm({state:'afiliacion_registro/servicios', data: this.dataForm[this.namePath].servicios_nuevos})
							const await10 = this.updateDataForm({state:'info_afiliacion/salariobase', data: this.dataForm[this.namePath].info_afiliacion.salario})

							await Promise.all([await1,await2,await3,await4,await5,await6,await7,await8,await9,await10])

							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: null, 
									tablaPost: ['info_ingresos','datos_afiliado','info_afiliacion','afiliacion_registro','servicios_activos','servicios_nuevos'],
									tablaDelete:[]
								}
							}) 
						break; 	
						case 'anularAfiliacionFtn':
							await this.updateDataForm({state: 'datos_afiliado', data: { id: this.dataForm[this.namePath].info_afiliacion.id_datos_afiliado, id_list_estado: 2 }})
							await this.updateDataForm({state: 'info_ingresos/anulado', data: 1})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									tablaAuditar: true, 
									notaDelete: this.dataForm[this.namePath].info_afiliacion.nota_delete, 
									tablaPost: ['info_afiliacion','info_ingresos','servicios_activos','servicios_nuevos','afiliacion_registro','datos_afiliado'],
									tablaDelete:['info_afiliacion','info_ingresos','servicios_activos','servicios_nuevos',]
								}
							}) 
							 
						break;
						case 'editarFichaFtn': 
							let serviciosActivos = this.deepCopy(this.dataForm[this.namePath].servicios_activos)

							let await01 = this.resetDataForm({state: 'servicios_nuevos'}) 
							let await02 = this.resetDataForm({state: 'servicios_activos'}) 

							await Promise.all([await01,await02])
							
							let awaitfor=[]
							let indexActivos
							for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
							{
								indexActivos= _.findIndex(serviciosActivos, ['name',this.dataMultiple[this.namePath].multiple_servicios[i].name])
								if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled===0 && indexActivos===-1)
								{				
									let newValue= this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])	
									newValue.id=null	
									newValue.id_info_ingresos=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id_info_ingresos	
									newValue.id_afiliacion_registro=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id	
									awaitfor.push(this.pushDataForm({state:  'servicios_nuevos', data: newValue}))										
								}   
								if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && indexActivos!==-1)
								{	
									let newValue= this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])	
									newValue.id=null		
									newValue.id_info_ingresos=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id_info_ingresos	
									newValue.id_afiliacion_registro=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].afiliacion_registro.id	
									awaitfor.push(await this.pushDataForm({state:  'servicios_activos', data: newValue}))
								}         
							}
							
							await Promise.all(awaitfor)							

							var name = this.dataForm[this.namePath].datos_afiliado.nombre1+' '+this.dataForm[this.namePath].datos_afiliado.nombre2+' '+this.dataForm[this.namePath].datos_afiliado.apellido1+' '+this.dataForm[this.namePath].datos_afiliado.apellido2
								var re= /null/gi;

							await this.updateDataForm({state: 'datos_afiliado/name', data: name.replace(re,' ')})

							await this.updateDataPost({
								data: {
								  data: [],
								  tablaDelete: ['afiliacion_registro'],
								  tablaAuditar: true,
								  notaDelete: null,
								  tablaPost: ['datos_afiliado','info_afiliacion','afiliacion_registro','servicios_activos','servicios_nuevos'],
								  route: 'save_all'
								}
							})
						break
					}
				}

				await this.save(event.save)
				

				await this.getDataGet({route: 'get_aflinformes', data: {inicial: this.filter.inicial, final:  this.filter.final, others: []}})
				//frontend await this.searchIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})

				const await10 =  this.resetDataIndex()
				const await11 =  this.resetGlobal({state: 'openModal'})
				const await12 =  this.resetDataForm()
				const await13 =  this.resetGlobal({state: 'saveConfig/capa'}) 
				await await10
				await await11
				await await12
				await await13
			}
			catch{

			}			
		}		
	},
}
